import React, { Fragment, useState, useEffect, useContext } from "react";
import { Alert, Form, FormGroup, Input, Label } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import {
  EmailAddress,
  Password,
  RememberPassword,
} from "../../../../Shared/Constants";
import { useNavigate } from "react-router-dom";
import FormHeader from "./FormHeader";
import { useForm } from "react-hook-form";
import AuthContext from "../../ContextProvider";
import InputError from "../../../../Shared/Components/Form/InputError";
import { togleLoading } from "../../../../Shared/Utils/alertLoading";

const LoginTab = () => {
  //conetxt
  const { apiErrors, login, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  //state
  const [togglePassword, setTogglePassword] = useState(false);

  //form
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({ mode: "all" });

  const onSubmit = (data) => {
    login(data);
  };

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  const ToggleAlert = () => setAlertOpen(!alertOpen);
  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);

  useEffect(() => {
    togleLoading(loading);
  }, [loading]);

  return (
    <Fragment>
      <Alert
        className="alert-dismissible"
        color="danger inverse"
        isOpen={alertOpen}
        toggle={ToggleAlert}
      >
        <i class="icon-alert"></i>
        {apiErrors && apiErrors.length > 0 ? apiErrors[0] : ""}
      </Alert>
      <Form
        className="theme-form"
        onSubmit={handleSubmit(onSubmit)}
        id="authForm"
      >
        <FormHeader />
        <FormGroup className="form-group">
          <Label className="col-form-label">{EmailAddress}</Label>
          <input
            {...register("email", {
              required: "El email es obligatorio",
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: "El email no es valido",
              },
            })}
            className="form-control"
            type="email"
          />
          <InputError errors={errors} name="email" title="Email" />
        </FormGroup>
        <FormGroup className="form-group">
          <Label className="col-form-label">{Password}</Label>
          <div className="form-input position-relative">
            <input
              {...register("password", {
                required: "El password es obligatorio",
              })}
              className="form-control"
              type={togglePassword ? "text" : "password"}
              autoComplete=""
            />
            <div
              className="show-hide"
              onClick={() => setTogglePassword(!togglePassword)}
            >
              <span className={togglePassword ? "" : "show"}></span>
            </div>
          </div>
          <InputError errors={errors} name="password" title="Password" />
        </FormGroup>
        <FormGroup className="form-group mb-0">
          <div className="checkbox p-0">
            <Input id="checkbox1" type="checkbox" />
            <Label className="text-muted" for="checkbox1">
              {RememberPassword}
            </Label>
          </div>
        </FormGroup>
        <div className="text-end mt-3">
          <Btn
            attrBtn={{
              color: "primary w-100",
              className: "btn-block",
              type: "submit",
              disabled: loading,
            }}
          >
            Ingresar
          </Btn>
        </div>
      </Form>
    </Fragment>
  );
};
export default LoginTab;
